// @ts-check
import Popup from "Components/Common/popup";
import { observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';
import 'Styles/main.scss';
import IconsContainer from 'Utils/IconsContainer';

/**
 * @param {import("Stores/LeftPanel/MainItems").LeftPanelItemState} props
 * @returns {React.JSX.Element}
 */
const LeftPanelItem = (props) => {
    let isDisabled = props.isDisabled || props.isAvailable == false;

    let element =
        <Popup popupText={props.title}
            className='menu-popup'>
            <div
                className={
                    "menu-item" +
                    (props.isSelected ? ' selected' : '') +
                    (props.isError ? ' error-menu-item' : '') +
                    (isDisabled ? ' disabled-clickable' : '')
                }
                onClick={() => props.onClick?.(props)}
            >
                <div className='menu-line' />
                {IconsContainer.Get(props.icon)}
                {props.title}
            </div>
        </Popup>

    return (
        isDisabled
            ? (element)
            : props.linkTo.startsWith('#')
                ?
                (
                    <a href={props.linkTo}>
                        {element}
                    </a>
                )
                :
                (
                    <Link to={props.linkTo}>
                        {element}
                    </Link>
                )
    );
}

export default observer(LeftPanelItem);